import React, { useEffect, useState } from "react";
import { findAllPG, findAllParticularCategory } from "../../api/commonApi"; // make sure path is correct

const Facilities = ({ id }) => {
  const [buildingFacilities, setBuildingFacilities] = useState([]);
  const [flatFacilities, setFlatFacilities] = useState([]);

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const response = await findAllParticularCategory("Flat Facilities");
        if (response && response.data && response.data.length > 0) {
          const allFlats = response.data;
          const uniqueFlats = Array.from(
            new Map(allFlats.map((item) => [item.name, item])).values()
          );
          setFlatFacilities(uniqueFlats);
        }
        const response1 = await findAllParticularCategory("Building Facilities");
        if (response1 && response1.data && response1.data.length > 0) {
          const allBuilding = response1.data;
          const uniqueBuilding = Array.from(
            new Map(allBuilding.map((item) => [item.name, item])).values()
          );

          setBuildingFacilities(uniqueBuilding);
        }
      } catch (error) {
        console.error("Error fetching facilities:", error);
      }
    };

    fetchFacilities();
  }, []);

  const Pill = ({ icon, label }) => (
    <div className="flex items-center space-x-2 border border-[#FFEBB3] rounded-full px-4 py-2 bg-[#FFF8E1] text-[#8C1D40] text-sm font-medium">
      <img src={icon} alt={label} className="w-5 h-5" />
      <span>{label}</span>
    </div>
  );

  return (
    <section id={id} className="py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto text-center">
        {/* Building Facilities */}
        <h2 className="heading-style mb-8">
          Facilities{" "}
          <span className="heading-style text-[#87004C]">At Building</span>
        </h2>
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {buildingFacilities.length > 0 ? (
            buildingFacilities.map((item, idx) => (
              <Pill key={idx} icon={item.icon} label={item.name} />
            ))
          ) : (
            <p>No building facilities available</p>
          )}
        </div>

        {/* Flat Facilities */}
        <h2 className="heading-style mb-8">
          Facilities{" "}
          <span className="heading-style text-[#87004C]">At Flats</span>
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          {flatFacilities.length > 0 ? (
            flatFacilities.map((item, idx) => (
              <Pill key={idx} icon={item.icon} label={item.name} />
            ))
          ) : (
            <p>No flat facilities available</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
